var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldSconn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FDCA53"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 11.4,
    stroke: "black",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1317 20.696C18.5117 20.696 19.9257 19.254 19.9257 17.56C19.9257 16.076 19.0997 15.264 17.8537 14.746L16.4957 14.186C15.6137 13.836 14.8717 13.556 14.8717 12.814C14.8717 12.142 15.4457 11.736 16.3557 11.736C17.2097 11.736 17.8957 12.044 18.5677 12.59L19.6037 11.288C18.7637 10.434 17.5597 9.958 16.3557 9.958C14.2697 9.958 12.7717 11.26 12.7717 12.954C12.7717 14.452 13.8357 15.306 14.8717 15.726L16.2577 16.314C17.1817 16.706 17.8117 16.958 17.8117 17.728C17.8117 18.442 17.2517 18.904 16.1737 18.904C15.2637 18.904 14.2697 18.456 13.5417 17.77L12.3517 19.198C13.3597 20.164 14.7317 20.696 16.1317 20.696Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldSconn);
export default __webpack_public_path__ + "static/media/HoldSconn.8904819aa4f7f901395a66da494577d2.svg";
export { ForwardRef as ReactComponent };